/**
 * errorSnackBar.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

import * as React from "react";

import { Snackbar, Alert } from "@mui/material";


interface ErrorSnackBarProps {
  errMsg: string
  didClose?: () => void
}

export function ErrorSnackBar(props: ErrorSnackBarProps): React.ReactElement<any, any> {
  const [errMsg, setErrMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);

  if (props.errMsg && props.errMsg !== errMsg) {
    setErrMsg(props.errMsg);
    setOpen(true);
  } else if (!props.errMsg && open) {
    setOpen(false);
    setErrMsg("");
  }

  function close() {
    setOpen(false);
    setErrMsg("");
    props.didClose && props.didClose();
  }

  return <Snackbar open={open} autoHideDuration={8000} onClick={close}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    onClose={close}>

    <Alert elevation={6} variant="filled" severity="error">
      {errMsg}
    </Alert>
  </Snackbar>;
}
